import React, { FC, useCallback, useMemo } from "react";
import { PushpinOutlined } from "src/icons";
import { Input, Button, Modal, Form } from "antd";
import { ReactComponent as FilterIcon } from "src/assets/filter-icon.svg";
import colors from "src/styles/variables.scss";
import "./index.scss";

interface IPinMetricProps {
  showModal: boolean;
  handleSubmitPin: (e) => void;
  onModalClose: () => void;
  showFilter: (e) => void;
  filters: IObject<string[]>;
  isPending: boolean;
  title: string;
}

const flattenFilters = (filterObj: IObject<Array<string>>) => {
  return Object.entries(filterObj)
    .map(([key, value]) => {
      if (value.length) return value;
    })
    .filter((i) => (i ? true : false))
    .join(" | ");
};

const PinMetric: FC<IPinMetricProps> = (props) => {
  const { showModal, handleSubmitPin, onModalClose, showFilter, filters, isPending } = props;
  const [form] = Form.useForm();
  const { validateFields, getFieldValue, resetFields, getFieldsError } = form;

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      validateFields()
        .then(() => {
          handleSubmitPin(getFieldValue("pinMetric"));
          resetFields();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    [handleSubmitPin]
  );

  const handleCancel = useCallback((e) => {
    resetFields();
    onModalClose();
  }, []);

  const hasErrors = useCallback((fieldsError) => {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
  }, []);

  const filterText = useMemo(() => flattenFilters(filters), [filters]);

  return (
    <Modal
      title={
        <span>
          <PushpinOutlined />
          <span className="modal-header-text">Pin to focus metrics</span>
        </span>
      }
      visible={showModal}
      onOk={handleSubmit}
      onCancel={handleCancel}
      bodyStyle={{ paddingBottom: "5px" }}
      className="pin-modal"
      footer={null}
    >
      <Form onFinish={handleSubmit} form={form} initialValues={{ pinMetric: props.title }}>
        <Form.Item
          label="Metric Name"
          name="pinMetric"
          rules={[
            { required: true, message: "Please enter pinned metric name" },
            {
              max: 40,
              message: "Metric Name cannot be longer than 40 characters",
            },
          ]}
        >
          <Input placeholder="add pinned metric name" />
        </Form.Item>
        {filterText && <Form.Item label="Filters Applied">{filterText || "None"}</Form.Item>}
        <Form.Item>
          <Button className="add-filter-button" onClick={showFilter}>
            <FilterIcon style={{ color: colors.pureBlack }} className="mr-5" />
            Add Filters
          </Button>
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              block
              // disabled={isPending}
              disabled={isPending || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
            >
              Create Pin
            </Button>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PinMetric;
